import React from 'react';
const benefits = [{
  icon: '🚀',
  title: 'Smetti di pianificare a mano',
  desc: 'Unità didattiche complete mese per mese, dalla 1ª alla 5ª — allineate alle Indicazioni Nazionali.',
  stat: '−5 ore a settimana',
  color: 'from-blue-500/20 to-blue-600/5',
  borderColor: 'border-blue-500/20',
  statColor: 'text-blue-300 bg-blue-500/15 border-blue-500/25'
}, {
  icon: '🥁',
  title: 'Insegna senza saper suonare',
  desc: 'Oltre 100 attività di Body Percussion e Orff: corpo + voce = musica. Zero strumenti costosi richiesti.',
  stat: '0 strumenti necessari',
  color: 'from-green-500/20 to-green-600/5',
  borderColor: 'border-green-500/20',
  statColor: 'text-cta-green bg-cta-green/15 border-cta-green/30'
}, {
  icon: '💻',
  title: 'Affascina la classe con la LIM',
  desc: 'Slide visuali e spartiti colorati che rendono il pentagramma immediato e accessibile a tutti.',
  stat: 'Pronto in 2 clic',
  color: 'from-purple-500/20 to-purple-600/5',
  borderColor: 'border-purple-500/20',
  statColor: 'text-purple-300 bg-purple-500/15 border-purple-500/25'
}, {
  icon: '🎓',
  title: 'Includi davvero tutti gli alunni',
  desc: 'Sistema testato Kodály/Orff con percorsi semplificati per BES e DSA. Nessun bambino resta indietro.',
  stat: '100% inclusivo',
  color: 'from-secondary/20 to-secondary/5',
  borderColor: 'border-secondary/20',
  statColor: 'text-secondary bg-secondary/15 border-secondary/30'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* Eyebrow */}
        <div className="text-center mb-4" data-id="element-3">
          <span className="inline-flex items-center gap-2 text-primary font-bold text-xs sm:text-sm uppercase tracking-wider bg-primary/10 border border-primary/20 px-4 py-1.5 rounded-full" data-id="element-4">
            🎁 Cosa è incluso
          </span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-3 tracking-tight" data-id="element-5">
          Cosa cambierà nella tua{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-6">
            classe
          </span>{' '}
          (e nei tuoi weekend).
        </h2>
        <p className="text-text-sec text-base sm:text-lg text-center max-w-2xl mx-auto mb-14" data-id="element-7">
          4 trasformazioni concrete che noterai{' '}
          <span className="text-text-main font-bold" data-id="element-8">
            dalla prima settimana
          </span>{' '}
          di utilizzo.
        </p>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-7 mb-12" data-id="element-9">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-7 sm:p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 hover:-translate-y-1 hover:border-white/20 transition-all duration-300 relative overflow-hidden group" data-id="element-10">
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-11"></div>

              {/* Header row: icon + stat */}
              <div className="flex items-center justify-between gap-3 relative z-10" data-id="element-12">
                <div className={`w-14 h-14 rounded-2xl bg-bg-dark border ${benefit.borderColor} flex items-center justify-center text-3xl shadow-inner group-hover:scale-110 transition-transform duration-300`} data-id="element-13">
                  {benefit.icon}
                </div>
                <span className={`text-xs sm:text-sm font-black uppercase tracking-wider px-3 py-1.5 rounded-full border ${benefit.statColor}`} data-id="element-14">
                  {benefit.stat}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-black text-text-main relative z-10 leading-tight" data-id="element-15">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="text-text-sec leading-relaxed text-base sm:text-lg relative z-10" data-id="element-16">
                {benefit.desc}
              </p>
            </div>)}
        </div>

        {/* Inline testimonial bridge */}
        <div className="bg-bg-alt border border-cta-green/30 rounded-2xl p-6 sm:p-7 mb-10 max-w-3xl mx-auto relative overflow-hidden" data-id="element-17">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at left center, rgba(22,199,132,0.08) 0%, transparent 60%)'
        }} data-id="element-18"></div>
          <div className="relative flex items-start gap-4" data-id="element-19">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/30 to-cta-green/20 border border-cta-green/30 flex items-center justify-center text-xl flex-shrink-0" data-id="element-20">
              👩‍🏫
            </div>
            <div data-id="element-21">
              <div className="flex items-center gap-2 mb-1" data-id="element-22">
                <span className="text-secondary text-sm" data-id="element-23">⭐⭐⭐⭐⭐</span>
                <span className="text-text-sec text-xs font-medium" data-id="element-24">
                  Verificato
                </span>
              </div>
              <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed italic" data-id="element-25">
                "In due settimane ho recuperato i miei sabati. I bambini cantano
                in coro e io non ho più ansia di lunedì."
              </p>
              <p className="text-text-sec text-sm mt-2 font-medium" data-id="element-26">
                — Francesca M., Insegnante di 1ª · Milano
              </p>
            </div>
          </div>
        </div>

        {/* Soft CTA */}
        
      </div>
    </section>;
}